import CloseIcon from "@/components/_icons/closeIcon";
export interface ScanToOrderCartHeaderProps {
  onRequestClose: () => void;
}

export const ScanToOrderCartHeader = ({
  onRequestClose,
}: ScanToOrderCartHeaderProps) => {
  return (
    <div
      data-testid="scan-to-order-cart-header"
      className="min-h-14 justify-between px-4 flex shadow-md"
    >
      <p className="text-xl font-medium pt-[15px]">Your Cart</p>
      <button onClick={onRequestClose}>
        <CloseIcon />
      </button>
    </div>
  );
};
